import { Button } from '@sevenrooms/ui-kit/form'
import { VStack } from '@sevenrooms/ui-kit/layout'
import { Text } from '@sevenrooms/ui-kit/typography'
import { ErrorHeader } from './ErrorHeader'

export function FleeTheVoid() {
  return (
    <VStack height="100vh" width="100vw">
      <ErrorHeader />
      <VStack width="100%" flexGrow={1} alignItems="center" backgroundColor="darkFont" spacing="m" pt="m">
        <Text textStyle="body1" color="lightFont">
          There's nothing here. Only the void.
        </Text>
        <Button data-test="sr-flee-the-void" variant="primary" href="/" isExternal>
          <Text color="lightFont">Flee the void</Text>
        </Button>
      </VStack>
    </VStack>
  )
}
